(ns manatee.dashboard.view
  (:require [clojure.string :as string]
            [manatee.dashboard.handlers]
            [manatee.session.subs :as subs]
            [manatee.ui.templates :as templates]
            [re-frame.core :as rf]
            [rothko.collection-components.core :as collection]
            [rothko.collection-components.table.component :as table]
            [rothko.layout.component :refer [layout]]
            [rothko.panel.component :refer [panel]]))

(defn format-title
  [title]
  (-> title
      name
      string/capitalize
      (string/replace #"-" " ")))

(def ^{:doc "Friendly names of EST tasks for display on the Dashboard.
             Other tasks should be displayed simply by task name."}
  est-tasks->display
  {"est-scoring" "Scoring"
   "est-transcription-annotation" "Transcription annotation"
   "est-error-annotation" "Error annotation"})

(defn format-task-counts
  [task-counts]
  (let [task-name->display (fn [task-name]
                             (or (est-tasks->display task-name)
                                 (some-> task-name name format-title)))]
    (map #(update % :task task-name->display) task-counts)))

(defn dashboard-view
  [{:keys [timesheet task-counts class]}]
  [:div.dashboard__view {:class class}
   [panel {:appearance #{:primary}}
    [:h4 "Session time"]
    (into [layout]
          (for [[title {:keys [hours mins]}] timesheet]
            ^{:key title}
            [:div
             [:h5 (format-title title)]
             [:span (str hours " hours " mins " mins")]]))
    [:h4 "Completed tasks"]
    [layout {:appearance #{:column}
             :class [:dashboard-page__table-layout]}
     [table/component
      {:appearance #{:primary}
       ::collection/items (format-task-counts task-counts)
       ::collection/fields [{::collection/id :task ::collection/label "Task"}
                            {::collection/id :today ::collection/label "Today"}
                            {::collection/id :this-month ::collection/label "This Month"}
                            {::collection/id :last-month ::collection/label "Last Month"}
                            {::collection/id :remaining ::collection/label "Remaining"}]}]]]])

(defn container
  [props]
  (let [activity @(rf/subscribe [::subs/activity])]
    [dashboard-view (merge props activity)]))

(def page
  {:template templates/single-column
   :main container})
